import { render } from "./IqacCompositionView.vue?vue&type=template&id=bae365b6"
import script from "./IqacCompositionView.vue?vue&type=script&lang=js"
export * from "./IqacCompositionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__